<template>
  <div class="page-view">
    <template v-if="Array.isArray(sezenden)&&sezenden.length">
      <div class="side-menu">
        <ul class="menu-list">
          <router-link
              class="menu-btn"
              tag="li"
              :to="'/'+lng+'/sezenden'"
              active-class="active">
            <a
              href="javascript:;">{{t.sezen}}</a>
          </router-link>
        </ul>
      </div>
      <div class="content">
        <div class="content-header">
          <h3>{{t.sezen}}</h3>
        </div>
        <div class="content-list">
          <keep-alive>
            <router-view/>
          </keep-alive>
          <router-view name="id"/>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="spinner" v-if="Array.isArray(sezenden) && !sezenden.length">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <p class="response-error" v-if="sezenden==undefined">
        <span>{{ lng == 'tr' ? 'Kayıt bulunamadı' : 'No Records Found' }}</span>
      </p>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['t', 'lng', 'sezenden'])
  },
  async created() {
    await this.$store.dispatch('sezenden_list');
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../styles/announcements_partner';
</style> 
